import type { ICellRendererParams } from 'ag-grid-community';
import type { PriceSeries } from '../../schema';

// Two-line APMC cell: bold name + muted "district · state" subtitle so editors
// can disambiguate same-name APMCs across geographies.
export function ApmcCell(p: ICellRendererParams<PriceSeries>) {
  if (!p.data) return null;
  const { apmcName, apmcDistrictName, apmcStateName } = p.data;
  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">{apmcName}</span>
      <span className="mt-0.5 text-[11px] text-foreground-muted">
        {apmcDistrictName} · {apmcStateName}
      </span>
    </div>
  );
}
